<template>
	<div id="home">
		<!-- 顶部固定 -->
		<toptitle :title="title" :isShowBack="isShowBack"></toptitle>
		<!-- 中间渲染内容 -->
		<transition :name='transitionName'>
			<router-view></router-view>
		</transition>
		<!-- tabar -->
		<tabar :selected="selected"></tabar>
	</div>
</template>
<style lang="scss" scoped>
	#home {
		padding-top: 100px;
		padding-bottom: 110px;

		// overflow-x: hidden;
		.slide-left-leave-to,
		.slide-right-enter {
			opacity: 0;
			transform: translate3d(-100%, 0, 0);
		}

		.slide-left-enter,
		.slide-right-leave-to {
			opacity: 0;
			transform: translate3d(100%, 0, 0);
			position: absolute;
		}

		.slide-right-enter-active,
		.slide-right-leave-active,
		.slide-left-enter-active,
		.slide-left-leave-active {
			transition: all 0.5s ease;
		}

		// padding-bottom: 50px;
		// 		.fade-enter {
		// 			opacity: 0;
		// 			transform: translate3d(-100%, 0, 0);
		// 		}
		// 
		// 		.fade-leave-to {
		// 			opacity: 0;
		// 			transform: translate3d(100%, 0, 0);
		// 			position: absolute;
		// 		}
		// 
		// 		.fade-enter-active,
		// 		.fade-leave-active {
		// 			transition: all 0.5s ease;
		// 		}

		tabar {
			z-index: 999;
		}
	}
</style>
<script>
	import tabar from '@/components/Tabar';
	import toptitle from '@/components/Toptitle';
	export default {
		name: 'Home',
		data() {
			return {
				keepAlive: 'main-keep-alive', //需要缓存的页面 例如首页
				transitionName: 'slide-right', //初始过渡动画方向
				title: '成都西部甲状腺医院挂号平台', //titile
				isShowBack: false, //是否显示返回按钮
				selected: '首页', //tabar选中的
			}
		},
		created() {
			// tabar切换页面根据路由改变title
			if (this.$route.path === '/home/index') {
				this.title = '成都西部甲状腺医院挂号平台';
				this.selected = '首页';
			} else if (this.$route.path === '/home/yyjj') {
				this.title = '医院简介';
				this.selected = '医院简介';
				this.isShowBack = true;
			} else if (this.$route.path === '/home/activity') {
				this.title = '活动中心';
				this.isShowBack = true;
				// this.selected = '活动中心';
			}
		},
		watch: {
			$route(to, from) {
				// console.log(to.path);
				// 监听路由 根据路由改变title
				if (to.path == '/home/index') {
					this.title = '成都西部甲状腺医院挂号平台';
					this.selected = '首页';
				} else if (to.path == '/home/yyjj') {
					this.title = '医院简介';
					this.selected = '医院简介';
					this.isShowBack = true;
				} else if (to.path == '/home/activity') {
					this.title = '活动中心';
					this.isShowBack = true;
					// this.selected = '活动中心';
				}
				// 切换动画
				// let isBack = this.$router.isBack // 监听路由变化时的状态为前进还是后退
				// if (isBack) {
				// 	this.transitionName = 'slide-left'
				// } else {
				// 	this.transitionName = 'slide-right'
				// }
				// this.$router.isBack = false
			}
		},
		components: {
			tabar,
			toptitle,
			// search
		},
		methods: {

		}
	};
</script>
